import { json_headers, request } from './common';

const baseSalesforcePath = `${window.configs.API_HOST}/api/zendesk/salesforce`;

export type SalesforceUserLicensePoolRequest = {
  id?: string;
  userId: string;
  startDateTime: string;
  endDateTime: string;
  extensionCount: number;
};

export type SalesforceUserLicensePoolAccess = {
  userId: string;
  hasAccess: boolean;
  defaultAccessTime: number;
  licensePoolRequest?: SalesforceUserLicensePoolRequest;
};

export const getSalesforceUserLicensePoolAccess = async (email: string): Promise<SalesforceUserLicensePoolAccess> => {
  const uri = `${baseSalesforcePath}/license-pool/access?email=${email}`;

  const response = await request(uri, {
    method: 'GET',
    headers: json_headers,
  });
  return response.result;
};

export const createSalesforceUserLicenseRequest = async ({
  licenseRequest,
}: {
  licenseRequest: SalesforceUserLicensePoolRequest;
}) => {
  const url = `${baseSalesforcePath}/license-pool/request`;
  const body = {
    licensePoolRequest: licenseRequest,
  };
  const response = await request(url, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(body),
  });
  return response;
};
